<div class="rerun-renderer">
  @if (isCompleted() && !isSubmitting) {
  <div class="completed">
    <a (click)="reRun()">Rerun search</a>
  </div>
  } @if (isReRunInProgress() && !isCancelling()) {
  <div class="rerun">
    Rerun busy @if (!isCancelling() && !isSubmitting) {
    <mat-icon class="cancel" (click)="cancelResultsDelivery()"></mat-icon>
    }
  </div>
  } @if (isNewSearchInProgress() && !isCancelling()) {
  <div class="new-search">
    New Search@if (!isCancelling() && !isSubmitting) {
    <mat-icon class="cancel" (click)="cancelResultsDelivery()"></mat-icon>
    }
  </div>
  } @if (isCancelling()) {
  <div class="cancel-search">Cancelling...</div>
  }
</div>
